import { render, staticRenderFns } from "./Etapa10.vue?vue&type=template&id=c9f0f80a&scoped=true"
import script from "./Etapa10.vue?vue&type=script&lang=js"
export * from "./Etapa10.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=c9f0f80a&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa10.vue?vue&type=style&index=1&id=c9f0f80a&prod&lang=css"
import style2 from "./Etapa10.vue?vue&type=style&index=2&id=c9f0f80a&prod&lang=scss"
import style3 from "./Etapa10.vue?vue&type=style&index=3&id=c9f0f80a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f0f80a",
  null
  
)

export default component.exports